import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { Text } from '../text/text.js';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function RadioButton({ label, name, value, selected, onSelected, disabled, error, required, inputProps, }) {
    return (jsxs(StyledLabel, { children: [jsx(StyledRadioButton, { "$error": error, children: jsx("div", { className: "inner" }) }), jsx(VisuallyHiddenInput, { type: "radio", name: name, onChange: (e) => {
                    onSelected?.(e.target.value, e);
                }, disabled: disabled, required: required, value: value, checked: selected, ...inputProps }), jsx(Text, { color: "unset", children: label })] }));
}
const StyledLabel = styled.label `
  display: inline-flex;
  align-items: center;
  gap: ${spacing.S};
  cursor: pointer;

  &:has(input:disabled) {
    cursor: auto;
    color: ${colors.neutralDark2};
  }
`;
const StyledRadioButton = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 2px solid
    ${({ $error }) => ($error ? colors.systemError : colors.neutralDark3)};
  border-radius: 9999px;
  transition: border-color 100ms;

  .inner {
    width: 10px;
    height: 10px;
    border-radius: 9999px;
    background-color: ${colors.primary};
    opacity: 0;
    transition: opacity 100ms;
  }

  &:hover:not(:has(+ input:disabled)) {
    border-color: ${colors.primary};
  }

  &:has(+ input:checked:not(:disabled)) {
    border-color: ${colors.primary};

    .inner {
      opacity: 1;
    }
  }

  &:has(+ input:disabled) {
    border-color: ${colors.neutralDark2};
  }

  &:has(+ input:focus-visible) {
    outline: 1px solid ${colors.textPrimary};
    outline-offset: 1px;
  }
`;
const VisuallyHiddenInput = styled.input `
  position: absolute;
  height: 0;
  width: 0;
  opacity: 0;
`;

export { RadioButton };
